/* eslint-disable no-useless-escape */
import {
    ButtonPrimary,
    Callout,
    IconInformationUserRegular,
    Text3,
    ButtonFixedFooterLayout,
    PhoneNumberField,
    EmailField,
    IconChevronLeftRegular,
    NavigationBar,
    Text2,
    Text5,
    skinVars,
    Text4,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './index.scss';
import { useTranslation } from 'react-i18next';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { updateCustomerData } from '../../../../services/CustomerService';
import { formatMobileNumber } from '../../../../utils/dataTransformation/unitsConversion';
import { setInfoError } from '../../../../utils/dataTransformation/errorMesssages';
import FeedbackChangeData from './feedbackChangeData';
import ContactInfoVerificationStep1 from '../../../Escalation/Otp/contactInfoVerification/contactInfoVerificationStep1';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import SnackbarMessage from '../../../../components/SnackbarMessage';
import useUserlight from '../../../../hooks/useUserLight';
import { useQueryClient } from '@tanstack/react-query';

export interface ChangePersonalDataInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    typeVerificationDesktop?: string;
    currentMobileDesktop?: any;
    currentEmailDesktop?: any;
    fromOnboardingDesktop?: any;
}

export const ChangePersonalData: React.FC<ChangePersonalDataInterface> = ({
    fromDesktop,
    setComponentSelected,
    typeVerificationDesktop,
    currentMobileDesktop,
    currentEmailDesktop,
    fromOnboardingDesktop,
}: ChangePersonalDataInterface) => {
    const { t } = useTranslation();
    const isLight = useUserlight();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { trackingScreenView } = new TrackingEvents();
    const typeVerification = fromDesktop ? typeVerificationDesktop : params.get('typeVerification')!;
    const currentMobile = fromDesktop ? currentMobileDesktop : params.get('currentMobile')!;
    const currentEmail = fromDesktop ? currentEmailDesktop : params.get('currentEmail')!;
    const fromOnboarding = fromDesktop ? fromOnboardingDesktop : params.get('fromOnboarding')!;
    const [valueMobile, setValueMobile] = useState<any>('');
    const [valueEmail, setValueEmail] = useState<any>('');
    const [checkButton, setCheckButton] = useState<boolean>(false);
    const mobile = formatMobileNumber(currentMobile);
    const email = currentEmail;
    const queryClient = useQueryClient();

    const validateEmail = () => {
        let aux: boolean;
        const validRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (valueEmail.match(validRegex)) {
            aux = true;
        } else {
            aux = false;
        }
        return aux;
    };

    const personalData = () => {
        let aux: any;
        if (valueEmail === '') {
            aux = { contactNumber: valueMobile };
        } else if (valueMobile === '') {
            aux = { email: valueEmail };
        }
        return aux;
    };

    const sendToNative = (param: any, description: any, err?: any) => {
        const checkTitleFeedback = () => {
            let aux: any;
            if (typeVerification === 'mobile' && description === 'SUCCESS') {
                aux = t('profileChangeMobileFeedbackSuccessTitle');
            } else if (typeVerification == 'email' && description === 'SUCCESS') {
                aux = t('profileChangeEmailFeedbackSuccessTitle');
            } else if (description === 'ERROR') {
                aux = err.title;
            }
            return aux;
        };
        const checkSubtitleFeedback = () => {
            let aux: any;
            if (typeVerification === 'mobile' && description === 'SUCCESS') {
                aux = t('profileChangeMobileFeedbackSuccessSubtitle');
            } else if (typeVerification == 'email' && description === 'SUCCESS') {
                aux = t('profileChangeEmailFeedbackSuccessSubtitle');
            } else if (description === 'ERROR') {
                aux = err.localizedDescription;
            }
            return aux;
        };
        const titleFeedback = checkTitleFeedback();
        const subtitleFeedback = checkSubtitleFeedback();
        const queryParams = {
            title: titleFeedback,
            subtitle: subtitleFeedback,
            state: description,
            errorCode: err ? err.id : '',
        };
        if (fromOnboarding === 'true') {
            const url = param;
            navigate(url, {
                state: {
                    fromOnboarding: fromOnboarding,
                    ...queryParams,
                    err,
                    typeVerification: typeVerification,
                    stateFeedback: description,
                },
            });
        } else {
            navigate(param, {
                state: {
                    fromOnboarding: fromOnboarding,
                    err,
                    typeVerification: typeVerification,
                    stateFeedback: description,
                },
            });
        }
    };

    const getInfoCostumerDataUpdate = () => {
        updateCustomerData(personalData())
            .then(() => {
                queryClient.invalidateQueries({ queryKey: ['customer-data'] });
                if (fromDesktop) {
                    setComponentSelected(
                        <FeedbackChangeData
                            fromDesktop={fromDesktop}
                            setComponentSelected={setComponentSelected}
                            fromOnboardingDesktop={fromOnboarding}
                            typeVerificationDesktop={typeVerification}
                            stateFeedbackDesktop={'SUCCESS'}
                        ></FeedbackChangeData>,
                    );
                } else {
                    sendToNative('/profile/personal-data/change/feedback', 'SUCCESS');
                }
            })
            .catch((error: any) => {
                if (fromDesktop) {
                    setComponentSelected(
                        <FeedbackChangeData
                            fromDesktop={fromDesktop}
                            setComponentSelected={setComponentSelected}
                            fromOnboardingDesktop={fromOnboarding}
                            typeVerificationDesktop={typeVerification}
                            stateFeedbackDesktop={'ERROR'}
                            errDesktop={setInfoError(error)}
                        ></FeedbackChangeData>,
                    );
                } else {
                    sendToNative('/profile/personal-data/change/feedback', 'ERROR', setInfoError(error));
                }
            });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        if (typeVerification === 'mobile') {
            setCheckButton(!valueMobile || (valueMobile && valueMobile.length !== 9));
        } else if (typeVerification === 'email') {
            setCheckButton(!validateEmail());
        }
    }, [valueMobile, valueEmail]);

    if (isLight) {
        return <SnackbarMessage url='/profile' timeout={3000} />;
    }

    return (
        <div className='personal-data-change'>
            {!(isWebviewAndroid || isWebviewIOS) ? (
                <div className='personal-data-changeMobile__header-navigationBar'>
                    <NavigationBar
                        onBack={() => {
                            navigate(-1);
                        }}
                        title={typeVerification === 'mobile' ? t('titleMobileChange') : t('titleEmailChange')}
                    />
                </div>
            ) : fromOnboarding === 'true' ? (
                <div
                    className='personal-data-changeMobile__header-navigationBar'
                    style={{
                        background: skinVars.colors.navigationBarBackground,
                        height: '44px',
                    }}
                >
                    <Text4 regular color={skinVars.colors.textNavigationBarPrimary}>
                        {typeVerification === 'mobile' ? t('titleMobileChange') : t('titleEmailChange')}
                    </Text4>
                </div>
            ) : (
                <div></div>
            )}
            <ButtonFixedFooterLayout
                button={
                    <ButtonPrimary
                        disabled={checkButton}
                        onPress={() => {
                            getInfoCostumerDataUpdate();
                        }}
                    >
                        {t('save')}
                    </ButtonPrimary>
                }
            >
                <div className='personal-data-change__wrapper'>
                    {fromDesktop && (
                        <>
                            <div
                                className='personal-data-change__wrapper__header-return'
                                onClick={() => {
                                    if (fromOnboardingDesktop === 'true') {
                                        setComponentSelected(
                                            <ContactInfoVerificationStep1
                                                fromDesktop={true}
                                                setComponentSelected={setComponentSelected}
                                            ></ContactInfoVerificationStep1>,
                                        );
                                    }
                                }}
                            >
                                <div className='personal-data-change__wrapper__header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.textLink} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.textLink}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                            <div className='personal-data-change__wrapper__titleDesktop'>
                                <Text5 color={skinVars.colors.textPrimary}>
                                    {typeVerification === 'mobile' ? t('titleMobileChange') : t('titleEmailChange')}
                                </Text5>
                            </div>
                        </>
                    )}

                    <div className='personal-data-change__wrapper__text1'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {typeVerification === 'mobile'
                                ? t('personalDataChangeMobileText1')
                                : t('personalDataChangeEmailText1')}
                        </Text3>
                    </div>
                    <div className='personal-data-change__wrapper__number'>
                        <Text3 medium color={skinVars.colors.textSecondary}>
                            {typeVerification === 'mobile' ? mobile : email}
                        </Text3>
                    </div>
                    <div className='personal-data-change__wrapper__text2'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {typeVerification === 'mobile'
                                ? t('personalDataChangeMobileText2')
                                : t('personalDataChangeEmailText2')}
                        </Text3>
                    </div>
                    <div className='personal-data-change__wrapper__inputField'>
                        {typeVerification === 'mobile' ? (
                            <PhoneNumberField
                                value={valueMobile}
                                name='phone'
                                label={t('personalDataNewContactPhone')}
                                helperText={t('personalDataHelperTextMobile')}
                                onChangeValue={setValueMobile}
                            />
                        ) : (
                            <EmailField
                                value={valueEmail}
                                name='email'
                                label={t('personalDataNewEmail')}
                                helperText={t('personalDataHelperTextEmail')}
                                onChangeValue={setValueEmail}
                            />
                        )}
                    </div>
                    <div className='personal-data-change__wrapper__callout'>
                        <Callout
                            asset={
                                <IconInformationUserRegular color={skinVars.colors.brand}></IconInformationUserRegular>
                            }
                            description={
                                typeVerification === 'mobile'
                                    ? t('personalDataCalloutMobile')
                                    : t('personalDataCalloutEmail')
                            }
                        />
                    </div>
                </div>
            </ButtonFixedFooterLayout>
        </div>
    );
};

export default ChangePersonalData;
